import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

type DeleteItemModalProps = {
  open: boolean,
  handleClose: () => void
  handleDeleteItem: () => void
}

export default function BasicModal({ open, handleClose, handleDeleteItem }: DeleteItemModalProps) {

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant='h4' textAlign={'center'} component={'div'} sx={{ mt: 2 }}>
                هل أنت متأكد أنك تريد حذف هذا المنتج؟        
          </Typography>
          <Box textAlign={'right'}>
            <Button variant='contained' sx={{ mr: 2 }} color='error' onClick={handleDeleteItem}>
                نعم
            </Button>
            <Button variant='outlined' color='info' onClick={handleClose}>
                لا
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}